var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, EventEmitter, OnInit, Output, QueryList, ViewChild, } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { config } from '../../../../../config/config';
import { CustomEventCommand, CustomPlaceCommand } from '../../../../commands/hub/custom.event.command';
import { VisitorPromotionImageCommand } from '../../../../commands/hub/visitor.promotion.image.command';
import { BaseComponent } from '../../../../common/components/base.component';
import { ConfirmModalComponent } from '../../../../common/components/confirm.modal/confirm.modal.component';
import { ConfirmModalActions, ConfirmModalData, } from '../../../../common/components/confirm.modal/confirm.modal.provider';
import { ModalService } from '../../../../common/services/modal.service';
import { HubVisitorPromotionImage } from '../../../../models/hub/hub.visitor.promotion.image';
import { AlertifyService } from '../../../../services/alertify.service';
import { ConfigService } from '../../../../services/config.service';
import { CustomizationApiService } from '../../../../services/customization.api.service';
import { HubApiService } from '../../../../services/hub.api.service';
import { ImageService } from '../../../../services/image.service';
import { HubFacebookLocationFeedsStore, HubFacebookPageFeedsStore, CustomBtnStore, ToggleAndDataSourceStore, EditorChoiceStore, } from '../../../../stores/hub.calendar.store';
import { HubComponent } from '../../hub.component';
import { HubVisitorFeatureToggle } from '../../../../models/hub/hub.visitor.feature.toggle';
import { LocalStorageService } from '../../../../services/localStorageService';
import { ImageSelectorCommand } from '../../../../common/components/image.selector/image.selector.component';
var MarketingComponent = /** @class */ (function (_super) {
    __extends(MarketingComponent, _super);
    function MarketingComponent(hubApiService, formBuilder, parent, customizationService, activatedRoute, imageService, modalService, customBtnStore, hubFacebookFeedsStore, hubFacebookLocationFeedsStore, toggleAndDataSourceStore, editorChoiceStore, alertify) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.hubApiService = hubApiService;
        _this.formBuilder = formBuilder;
        _this.parent = parent;
        _this.customizationService = customizationService;
        _this.activatedRoute = activatedRoute;
        _this.imageService = imageService;
        _this.modalService = modalService;
        _this.customBtnStore = customBtnStore;
        _this.hubFacebookFeedsStore = hubFacebookFeedsStore;
        _this.hubFacebookLocationFeedsStore = hubFacebookLocationFeedsStore;
        _this.toggleAndDataSourceStore = toggleAndDataSourceStore;
        _this.editorChoiceStore = editorChoiceStore;
        _this.alertify = alertify;
        _this.hubName = null;
        _this.apiAddress = ConfigService.config.apiAddress;
        _this.isHideEditorChoice = true;
        _this.editorChoiceForEvent = '';
        _this.editorChoiceForPlace = '';
        _this.isLoadingEditorChoice = false;
        _this.isTurnOnCustomEvent = true;
        _this.isTurnOnCustomPlace = true;
        _this.visitorPromotionImageCommand = new VisitorPromotionImageCommand();
        _this.visitorPromotionImage = new HubVisitorPromotionImage();
        _this.customEventCommand = new CustomEventCommand();
        _this.customPlaceCommand = new CustomPlaceCommand();
        _this.initialTitle = '';
        _this.isEditDisplayTitle = [];
        _this.isEditPlaceDisplayTitle = [];
        _this.defaultVisitorPromotionImg = null; //config.defaultVisitorPromotionImageUrl;
        _this.toggles = new HubVisitorFeatureToggle();
        _this.selectImgFile = new ImageSelectorCommand();
        _this.version = {
            event: {
                version: 'V2',
            },
            place: {
                version: 'V2',
            },
            tripPlanner: {
                version: 'V2',
            },
            clientDashboard: {
                version: 'V2',
            },
        };
        return _this;
    }
    MarketingComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.parent.location = 'Marketing';
        this.isLoadingEditorChoice = true;
        this.hubPages = [];
        this.hubLocations = [];
        this.visitorPromotionImage.link = '';
        this.promotionForm = this.formBuilder.group({
            link: [null, []],
            isTop: [null, []],
        });
        this.customEditorChoiceForm = this.formBuilder.group({
            editorChoiceForEvent: [null, []],
            editorChoiceForPlace: [null, []],
        });
        this.customEventForm = this.formBuilder.group({
            isEventOn: [null, []],
            isPlaceOn: [null, []],
            btnText: [null, [Validators.required]],
            placeBtnText: [null, [Validators.required]],
            type: [null, []],
            feedId: [null, []],
        });
        this.customizationService
            .getIsHideEditorChoice(this.hubName)
            .subscribe(function (isHideEditorChoice) {
            _this.isHideEditorChoice = isHideEditorChoice == undefined ? false : isHideEditorChoice;
            _this.isLoadingEditorChoice = false;
        });
        this.customizationService.getEditorChoice(this.hubName).subscribe(function (editorChoice) {
            _this.editorChoiceForEvent = editorChoice.editorChoiceForEvent || '';
            _this.editorChoiceForPlace = editorChoice.editorChoiceForPlace || '';
        });
        this.customizationService.getCustomEvent(this.hubName).subscribe(function (data) {
            var customEvents = data.customEvents || [];
            var customPlaces = data.customPlaces || [];
            _this.processCustomEvents(customEvents);
            _this.processCustomPlaces(customPlaces);
        });
        this.customizationService.getVisitorPromotionImage(this.hubName).subscribe(function (data) {
            _this.visitorPromotionImage.isDisabled = data.isDisabled || false;
            _this.visitorPromotionImage.link = data.link || '';
            _this.visitorPromotionImageCommand.isTop = data.isTop || false;
            if (data.image) {
                _this.visitorPromotionImage.image = data.image;
            }
            else {
                _this.visitorPromotionImage.image = _this.defaultVisitorPromotionImg;
            }
        });
        this.customizationService.getIgVersion(this.hubName).subscribe(function (version) {
            if (version && version.event) {
                _this.version = version;
            }
            console.log('version', version);
        });
        this.hubFacebookFeedsStore.pagesCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (hubPages) {
            _this.hubPages = hubPages.hubPages;
            _this.eventFeeds = hubPages.hubPages;
        });
        this.hubFacebookLocationFeedsStore.locationCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (hubLocations) {
            _this.hubLocations = hubLocations.hubPages || [];
            _this.placeFeeds = hubLocations.hubPages || [];
            var events = hubLocations.hubPages
                ? hubLocations.hubPages.filter(function (x) { return !config.placeSocialName.any(function (y) { return y === x.socialName; }); })
                : [];
            _this.hubPages &&
                _this.hubPages.forEach(function (page) {
                    page.title = page.title || '@' + page.name;
                });
            events.forEach(function (location) {
                if (!location.title.endsWith('Performers,Venues, Ticketing Websites') &&
                    !location.title.endsWith(location.socialName)) {
                    location.title = location.title + " - " + (location.socialName == 'eventful'
                        ? 'Performers,Venues, Ticketing Websites'
                        : location.socialName);
                }
            });
            _this.eventFeeds = _this.hubPages ? _this.hubPages.concat(events) : events;
        });
        this.toggleAndDataSourceStore.toggleAndDataSourceCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (toggleCommand) {
            if (toggleCommand.toggle) {
                _this.toggles = toggleCommand.toggle;
            }
        });
        setTimeout(function () {
            _this.parent.sidebar && _this.parent.sidebar.loadLocationFeeds();
        });
    };
    MarketingComponent.prototype.getCustomEventLink = function (id) {
        if (this.version.event.version === 'V2') {
            return "" + config.serverDomain + this.hubName + "/custom-events/" + id;
        }
        else if (this.version.event.version === 'V3') {
            return "" + config.serverDomainV3 + this.hubName + "/events/custom-events/" + id;
        }
        throw Error('Please check the version');
    };
    MarketingComponent.prototype.getCustomEventEmbedScript = function (id) {
        if (this.version.event.version === 'V2') {
            return "<div id=\"imgoingcalendar-wrapper\" route=\"/" + this.hubName + "/custom-events/" + id + "\" url-change=\"true\">\n              <app-root></app-root>\n              <script type=\"text/javascript\" src=\"https://imgoingcalendar.com/imgoingscript.js\"></script>\n            </div> ";
        }
        else if (this.version.event.version === 'V3') {
            return "<div id=\"imgoingcalendar-wrapper\" route=\"/" + this.hubName + "/events/custom-events/" + id + "\" url-change=\"true\">\n                <app-root></app-root>\n                <script type=\"text/javascript\" src=\"https://imgoingcalendar.com/imgoingscript.js\"></script>\n              </div> ";
        }
        throw Error('Please check the version');
    };
    MarketingComponent.prototype.copyCustomEventsEmbedScript = function (id) {
        var content = this.getCustomEventEmbedScript(id);
        this.copyContentToClipboard(content);
    };
    MarketingComponent.prototype.copyToClip = function (id) {
        var value = this.getCustomEventLink(id);
        var aux = document.createElement('input');
        aux.setAttribute('value', value);
        document.body.appendChild(aux);
        aux.select();
        document.execCommand('copy');
        document.body.removeChild(aux);
        alert('URL is copied to the clipboard');
    };
    MarketingComponent.prototype.dragEnter = function ($event) {
        console.log('enter');
        if ($event && $event.currentTarget) {
            this.restoreItemStyle();
            $event.currentTarget.style.border = '2px dashed green';
        }
    };
    MarketingComponent.prototype.restoreItemStyle = function () {
        this.customEventRows.toArray().forEach(function (x) {
            x.nativeElement.style.border = 'none';
        });
    };
    MarketingComponent.prototype.onItemDrop = function (e, targetIndex) {
        var _this = this;
        console.log({ e: e });
        console.log({ targetIndex: targetIndex });
        var dragItemIndex = this.customEventCommands.indexOf(e.dragData);
        console.log({ dragItemIndex: dragItemIndex });
        // swap items
        _a = [
            this.customEventCommands[dragItemIndex],
            this.customEventCommands[targetIndex],
        ], this.customEventCommands[targetIndex] = _a[0], this.customEventCommands[dragItemIndex] = _a[1];
        setTimeout(function () {
            _this.restoreItemStyle();
        });
        this.saveCustomEvent();
        var _a;
    };
    MarketingComponent.prototype.editDisplayTitle = function (index) {
        var _this = this;
        this.initialTitle = this.customEventCommands[index].btnText;
        for (var i = 0; i < this.isEditDisplayTitle.length; i++) {
            this.isEditDisplayTitle[i] = false;
        }
        setTimeout(function () {
            _this.isEditDisplayTitle[index] = true;
        });
    };
    MarketingComponent.prototype.editPlaceDisplayTitle = function (index) {
        var _this = this;
        this.initialTitle = this.customPlaceCommands[index].btnText;
        for (var i = 0; i < this.isEditPlaceDisplayTitle.length; i++) {
            this.isEditPlaceDisplayTitle[i] = false;
        }
        setTimeout(function () {
            _this.isEditPlaceDisplayTitle[index] = true;
        });
    };
    MarketingComponent.prototype.isEditAnyCategory = function () {
        return this.isEditDisplayTitle.some(function (x) { return x; }) || this.isEditPlaceDisplayTitle.some(function (x) { return x; });
    };
    MarketingComponent.prototype.cancelEditCustomEventBtnName = function (i) {
        this.customEventCommands[i].btnText = this.initialTitle;
        this.isEditDisplayTitle[i] = false;
    };
    MarketingComponent.prototype.cancelEditCustomPlaceBtnName = function (i) {
        this.customPlaceCommands[i].btnText = this.initialTitle;
        this.isEditPlaceDisplayTitle[i] = false;
    };
    MarketingComponent.prototype.updateCustomEventBtnName = function ($event, btn, index) {
        var _this = this;
        if (this.customEventCommands
            .map(function (x) { return x.btnText.toLowerCase(); })
            .some(function (item, index) {
            return _this.customEventCommands.map(function (x) { return x.btnText.toLowerCase(); }).indexOf(item) !== index;
        })) {
            this.alertify.warning('Custom category name must be unique.');
            $event.immediateComplete();
            return;
        }
        this.customEventCommand.isTurnOn = this.isTurnOnCustomEvent;
        this.customizationService
            .setCustomEvent(this.hubName, {
            isTurnOn: this.isTurnOnCustomEvent,
            customEvents: this.customEventCommands,
        })
            .finally($event.complete)
            .subscribe(function (customBtns) {
            _this.isEditDisplayTitle[index] = false;
            _this.customBtnStore.customBtnCommand.next(customBtns);
            _this.alertify.successfully('Update display text');
        });
    };
    MarketingComponent.prototype.updateCustomPlaceBtnName = function ($event, btn, index) {
        var _this = this;
        if (this.customPlaceCommands
            .map(function (x) { return x.btnText.toLowerCase(); })
            .some(function (item, index) {
            return _this.customPlaceCommands.map(function (x) { return x.btnText.toLowerCase(); }).indexOf(item) !== index;
        })) {
            this.alertify.warning('Custom category name must be unique.');
            $event.immediateComplete();
            return;
        }
        this.customPlaceCommand.isTurnOn = this.isTurnOnCustomPlace;
        this.customizationService
            .setCustomPlace(this.hubName, {
            isTurnOn: this.isTurnOnCustomPlace,
            customPlaces: this.customPlaceCommands,
        })
            .finally($event.complete)
            .subscribe(function (customBtns) {
            _this.isEditPlaceDisplayTitle[index] = false;
            _this.processCustomPlaces(customBtns.places);
            _this.customBtnStore.customBtnCommand.next(customBtns);
            _this.alertify.successfully('Update display text');
        });
    };
    MarketingComponent.prototype.saveIsEditorChoice = function () {
        var _this = this;
        this.customizationService
            .setIsHideEditorChoice(this.hubName, this.isHideEditorChoice)
            .subscribe(function () {
            _this.alertify.successfully("Change editor's choice status");
        });
    };
    MarketingComponent.prototype.saveEditorChoice = function ($event) {
        var _this = this;
        var params = {
            editorChoiceForEvent: this.editorChoiceForEvent || "EDITOR'S CHOICE",
            editorChoiceForPlace: this.editorChoiceForPlace || "EDITOR'S CHOICE",
        };
        this.customizationService
            .saveEditorChoice(this.hubName, params)
            .finally($event.complete)
            .subscribe(function () {
            _this.alertify.successfully("Edit editor's choice");
            _this.editorChoiceStore.infoCommand.next(params);
        });
    };
    MarketingComponent.prototype.savePromotion = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var base64, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.visitorPromotionImageCommand.link = this.visitorPromotionImage.link;
                        this.visitorPromotionImageCommand.isDisabled = this.visitorPromotionImage.isDisabled;
                        this.visitorPromotionImageCommand.isTop = this.visitorPromotionImage.isTop;
                        if (!this.selectImgFile.image) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.imageService.compressImageFileToBase64(this.selectImgFile.image, 1200)];
                    case 1:
                        base64 = _a.sent();
                        return [4 /*yield*/, this.hubApiService.uploadBase64ImageToAWS(base64, 1200)];
                    case 2:
                        res = _a.sent();
                        if (res.success) {
                            this.visitorPromotionImageCommand.image = res.url;
                        }
                        _a.label = 3;
                    case 3:
                        this.customizationService
                            .setVisitorPromotionImage(this.hubName, this.visitorPromotionImageCommand)
                            .finally(event.complete)
                            .subscribe(function () {
                            _this.alertify.successfully('Change promotion image');
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    // public saveCustomEvent(event: ButtonTriggerEvent) {
    //     this.customEventCommand.isTurnOn = this.isTurnOnCustomEvent;
    //     this.customizationService.setCustomEvent(this.hubName, {
    //         isTurnOn: this.isTurnOnCustomEvent,
    //         customEventCommands: this.customEventCommands
    //     })
    //         .finally(event.complete)
    //         .subscribe((customBtns: HubCustomBtn) => {
    //             this.alertify.successfully('Change custom event button');
    //             this.processCustomEvents(customBtns.events);
    //             this.customBtnStore.customBtnCommand.next(customBtns);
    //         });
    // }
    MarketingComponent.prototype.toggleCustomEvents = function () {
        var _this = this;
        if (!this.isTurnOnCustomEvent) {
            var actions = {
                confirm: function (event) {
                    _this.customEventCommands = [];
                    _this.customEventCommand.isTurnOn = _this.isTurnOnCustomEvent;
                    _this.customizationService
                        .setCustomEvent(_this.hubName, {
                        isTurnOn: _this.customEventCommand.isTurnOn,
                        customEvents: [],
                    })
                        .finally(event.complete)
                        .subscribe(function (customBtns) {
                        _this.customEventCommands = customBtns.events;
                        _this.customBtnStore.customBtnCommand.next(customBtns);
                        _this.alertify.successfully("Custom event category turned off}");
                    });
                },
                cancel: function (event) {
                    _this.isTurnOnCustomEvent = !_this.isTurnOnCustomEvent;
                },
            };
            var data = {
                confirmModalIcon: 'warning',
                confirmModalTitle: 'Alert',
                confirmModalDescription: "Are you sure you want to turn off the custom event category feature, this will remove all the existing custom categories",
                confirmModalConfirmButtonText: 'Yes',
                confirmModalCancelButtonText: 'No',
                isAsync: true,
            };
            this.modalService.show({
                component: ConfirmModalComponent,
                providers: [
                    { provide: ConfirmModalActions, useValue: actions },
                    { provide: ConfirmModalData, useValue: data },
                ],
            });
            return;
        }
        // turn on
        this.addNewAndSaveEvent();
    };
    MarketingComponent.prototype.toggleCustomPlaces = function () {
        var _this = this;
        if (!this.isTurnOnCustomPlace) {
            var actions = {
                confirm: function (event) {
                    _this.customPlaceCommands = [];
                    _this.customPlaceCommand.isTurnOn = _this.isTurnOnCustomPlace;
                    _this.customizationService
                        .setCustomPlace(_this.hubName, {
                        isTurnOn: _this.customPlaceCommand.isTurnOn,
                        customPlaces: [],
                    })
                        .finally(event.complete)
                        .subscribe(function (customBtns) {
                        _this.customPlaceCommands = customBtns.places;
                        _this.customBtnStore.customBtnCommand.next(customBtns);
                        _this.alertify.successfully("Custom place category turned off}");
                    });
                },
                cancel: function (event) {
                    _this.isTurnOnCustomPlace = !_this.isTurnOnCustomPlace;
                },
            };
            var data = {
                confirmModalIcon: 'warning',
                confirmModalTitle: 'Alert',
                confirmModalDescription: "Are you sure you want to turn off the custom place category feature, this will remove all the existing custom categories",
                confirmModalConfirmButtonText: 'Yes',
                confirmModalCancelButtonText: 'No',
                isAsync: true,
            };
            this.modalService.show({
                component: ConfirmModalComponent,
                providers: [
                    { provide: ConfirmModalActions, useValue: actions },
                    { provide: ConfirmModalData, useValue: data },
                ],
            });
            return;
        }
        // turn on
        this.addNewAndSavePlace();
    };
    MarketingComponent.prototype.saveCustomEvent = function (event) {
        var _this = this;
        this.customEventCommand.isTurnOn = this.isTurnOnCustomEvent;
        this.customizationService
            .setCustomEvent(this.hubName, {
            isTurnOn: this.customEventCommand.isTurnOn,
            customEvents: this.customEventCommands,
        })
            .finally(event && event.complete)
            .subscribe(function (customBtns) {
            _this.processCustomEvents(customBtns.events);
            _this.customBtnStore.customBtnCommand.next(customBtns);
            _this.alertify.successfully('Custom event category saved');
        });
    };
    MarketingComponent.prototype.saveCustomPlace = function (event) {
        var _this = this;
        this.customPlaceCommand.isTurnOn = this.isTurnOnCustomPlace;
        this.customizationService
            .setCustomPlace(this.hubName, {
            isTurnOn: this.customPlaceCommand.isTurnOn,
            customPlaces: this.customPlaceCommands,
        })
            .finally(event && event.complete)
            .subscribe(function (customBtns) {
            _this.processCustomPlaces(customBtns.places);
            _this.customBtnStore.customBtnCommand.next(customBtns);
            _this.alertify.successfully('Custom place category saved');
        });
    };
    MarketingComponent.prototype.addNewAndSaveEvent = function () {
        this.addNewCustomEventTab();
        this.saveCustomEvent();
    };
    MarketingComponent.prototype.addNewAndSavePlace = function () {
        this.addNewCustomPlaceTab();
        this.saveCustomPlace();
    };
    MarketingComponent.prototype.addNewCustomEventTab = function () {
        this.customEventCommands.push(this.createNewCustomEventCommand());
    };
    MarketingComponent.prototype.addNewCustomPlaceTab = function () {
        this.customPlaceCommands.push(this.createNewCustomPlaceCommand());
    };
    MarketingComponent.prototype.removeCustomEventBtn = function (id) {
        var _this = this;
        var actions = {
            confirm: function (event) {
                _this.hubApiService
                    .deleteCustomEventBtn(_this.hubName, id)
                    .finally(event.complete)
                    .subscribe(function (customBtns) {
                    _this.alertify.successfully('Delete custom event button');
                    _this.processCustomEvents(customBtns.events);
                    _this.customBtnStore.customBtnCommand.next(customBtns);
                });
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to delete this button?',
            confirmModalConfirmButtonText: 'Delete',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    MarketingComponent.prototype.removeCustomPlaceBtn = function (id) {
        var _this = this;
        var actions = {
            confirm: function (event) {
                _this.hubApiService
                    .deleteCustomPlaceBtn(_this.hubName, id)
                    .finally(event.complete)
                    .subscribe(function (customBtns) {
                    _this.alertify.successfully('Delete custom place button');
                    _this.processCustomPlaces(customBtns.places);
                    _this.customBtnStore.customBtnCommand.next(customBtns);
                });
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to delete this button?',
            confirmModalConfirmButtonText: 'Delete',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    MarketingComponent.prototype.transferPlaces = function (place) {
        var _this = this;
        var actions = {
            confirm: function (event) {
                _this.hubApiService
                    .transferPlaces(_this.hubName, place._id)
                    .finally(event.complete)
                    .subscribe(function () {
                    _this.alertify.successfully('Transfer places');
                });
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to transfer all places belong to this category to the corresponding custom place category?',
            confirmModalConfirmButtonText: 'Confirm',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        var isSameNameCustomCategoryExist = this.checkIfSameNameCustomCategoryExist(place);
        if (isSameNameCustomCategoryExist) {
            this.modalService.show({
                component: ConfirmModalComponent,
                providers: [
                    { provide: ConfirmModalActions, useValue: actions },
                    { provide: ConfirmModalData, useValue: data },
                ],
            });
        }
        else {
            this.alertify.warning("You need to create a custom place category in the below \"Organize & Edit Places Categories\" section with the name \"" + place.btnText + "\" before transferring places", 10);
        }
    };
    MarketingComponent.prototype.getCustomPlaceEmbedScript = function (placeId) {
        return "<div id=\"imgoingcalendar-wrapper\" route=\"/" + this.hubName + "/places/fav/" + placeId + "\" url-change=\"true\">\n          <app-root></app-root>\n          <script type=\"text/javascript\" src=\"https://imgoingcalendar.com/imgoingscript.js\"></script>\n      </div> ";
    };
    MarketingComponent.prototype.getCustomPlaceMapViewEmbedScript = function (placeId) {
        return "<div id=\"imgoingcalendar-wrapper\"\n    route=\"/" + this.hubName + "/places-map/custom-places/" + placeId + "\" url-change=\"true\">\n    <app-root></app-root>\n    <script type=\"text/javascript\" src=\"https://imgoingcalendar.com/imgoingscript.js\"></script>\n    </div>";
    };
    MarketingComponent.prototype.copyEmbedScript = function (placeId, type) {
        var script = type === 'url'
            ? this.getCustomPlaceEmbedScript(placeId)
            : this.getCustomPlaceMapViewEmbedScript(placeId);
        this.copyContentToClipboard(script);
    };
    MarketingComponent.prototype.copyContentToClipboard = function (content) {
        var aux = document.createElement('input');
        aux.setAttribute('value', content);
        document.body.appendChild(aux);
        aux.select();
        document.execCommand('copy');
        document.body.removeChild(aux);
        this.alertify.success('Link is copied to the clipboard');
    };
    MarketingComponent.prototype.copyJsonFeed = function (placeId) {
        var content = this.apiAddress + "v2.0/" + this.hubName + "/places?type=" + placeId;
        var aux = document.createElement('input');
        aux.setAttribute('value', content);
        document.body.appendChild(aux);
        aux.select();
        document.execCommand('copy');
        document.body.removeChild(aux);
        this.alertify.success('Link is copied to the clipboard');
    };
    MarketingComponent.prototype.checkIfSameNameCustomCategoryExist = function (place) {
        var customDefaultPlaceCategory = LocalStorageService.getCustomDefaultPlaceCategoryFromLocalStorage();
        var isSameNameCustomCategoryExist = false;
        if (customDefaultPlaceCategory && customDefaultPlaceCategory.customCategories) {
            for (var _i = 0, _a = customDefaultPlaceCategory.customCategories; _i < _a.length; _i++) {
                var customCategory = _a[_i];
                var exist = this.getIfCategoryExistsInCustomCreated(place.btnText, customCategory);
                if (exist) {
                    isSameNameCustomCategoryExist = true;
                    break;
                }
            }
        }
        return isSameNameCustomCategoryExist;
    };
    MarketingComponent.prototype.getIfCategoryExistsInCustomCreated = function (title, category) {
        console.log("category.title: " + category.title + ",", "title: " + title);
        console.log(category.title.toLowerCase() === title.toLowerCase());
        if (category.title.toLowerCase() === title.toLowerCase()) {
            return true;
        }
        for (var _i = 0, _a = category.subCategories; _i < _a.length; _i++) {
            var subCategory = _a[_i];
            var exist = this.getIfCategoryExistsInCustomCreated(title, subCategory);
            if (exist)
                return true;
        }
        return false;
    };
    MarketingComponent.prototype.processCustomEvents = function (customEvents) {
        var _this = this;
        this.customEventCommands = [];
        this.isEditDisplayTitle = [];
        if (customEvents && customEvents.length) {
            this.isTurnOnCustomEvent = true;
            customEvents.forEach(function (event) {
                _this.customEventCommands.push(_this.createNewCustomEventCommand(event._id, event.btnText, event.sourceType, event.feedId, event.pageFeedId, event.locationFeedId));
                _this.isEditDisplayTitle.push(false);
            });
        }
        else {
            this.isTurnOnCustomEvent = false;
            // this.customEventCommands.push(this.createNewCustomEventCommand());
        }
    };
    MarketingComponent.prototype.processCustomPlaces = function (customPlaces) {
        var _this = this;
        this.customPlaceCommands = [];
        this.isEditPlaceDisplayTitle = [];
        if (customPlaces && customPlaces.length) {
            this.isTurnOnCustomPlace = true;
            customPlaces.forEach(function (place) {
                _this.customPlaceCommands.push(_this.createNewCustomPlaceCommand(place._id, place.btnText));
                _this.isEditPlaceDisplayTitle.push(false);
            });
        }
        else {
            this.isTurnOnCustomPlace = false;
            //this.customPlaceCommands.push(this.createNewCustomPlaceCommand());
        }
    };
    MarketingComponent.prototype.createNewCustomEventCommand = function (_id, btnText, type, feedId, pageFeedId, locationFeedId) {
        var command = new CustomEventCommand();
        command._id = _id || null;
        command.btnText = btnText || 'Custom Event Tab #' + (this.customEventCommands.length + 1);
        command.sourceType = type || 'selected';
        command.feedId = feedId || '';
        command.pageFeedId = pageFeedId || '';
        command.locationFeedId = locationFeedId || '';
        if (!_id)
            delete command._id;
        return command;
    };
    MarketingComponent.prototype.createNewCustomPlaceCommand = function (_id, btnText) {
        var command = new CustomPlaceCommand();
        command._id = _id || null;
        command.btnText = btnText || 'Custom Place Tab #' + (this.customPlaceCommands.length + 1);
        return command;
    };
    return MarketingComponent;
}(BaseComponent));
export { MarketingComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/customization/marketing/marketing.component.ts.pre-build-optimizer.js